import React, { useEffect } from 'react';
import { useAuth } from './auth/AuthContext';
import { ChatContainer } from './components/ChatContainer';
import { appConfig } from './config/appConfig';

const API_URL = appConfig.aws.chatApiUrl;

function App() {
  const { isAuthenticated, signIn, signOut } = useAuth();

  useEffect(() => {
    document.title = appConfig.display.appName;
    
    // Apply saved theme on load
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const isDark = savedTheme === 'dark' || (!savedTheme && prefersDark);
    
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 p-4 flex items-center justify-center">
        <div className="max-w-4xl w-full">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden border border-gray-200 dark:border-gray-700">
            <div className="grid md:grid-cols-5 gap-0">
              {/* Left accent bar */}
              <div className="hidden md:block bg-blue-600 dark:bg-blue-700 p-8">
                <div className="h-full flex flex-col justify-center space-y-6">
                  <div className="w-12 h-12 bg-white/10 rounded-lg"></div>
                  <div className="w-16 h-16 bg-white/10 rounded-lg"></div>
                  <div className="w-12 h-12 bg-white/10 rounded-lg"></div>
                </div>
              </div>
              
              {/* Main content */}
              <div className="md:col-span-4 p-8 md:p-12">
                <div className="mb-2">
                  <div className="inline-block px-4 py-1 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-full text-sm font-medium mb-6">
                    AI-Powered Knowledge Assistant
                  </div>
                </div>
                
                <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900 dark:text-white">
                  {appConfig.display.appName}
                </h1>
                
                <p className="text-xl text-gray-700 dark:text-gray-300 font-medium mb-6">
                  {appConfig.display.appTagline}
                </p>
                
                <div className="space-y-4 mb-8 pl-4 border-l-4 border-blue-500">
                  <p className="text-base text-gray-700 dark:text-gray-300">
                    {appConfig.display.signInPage.subtitle}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                    {appConfig.display.signInPage.description}
                  </p>
                </div>
                
                <div className="mb-8 p-3 bg-gray-100 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
                  <p className="text-sm text-gray-700 dark:text-gray-300">
                    <span className="font-medium">Demo Application:</span> This demonstration showcases Amazon Bedrock Knowledge Bases with retrieval-augmented generation (RAG) capabilities.
                  </p>
                </div>
                
                <button
                  onClick={signIn}
                  className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
                >
                  Sign In
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <ChatContainer apiUrl={API_URL} onSignOut={signOut} />;
}

export default App;
